if (!customElements.get('zone-collection')) {
  customElements.define(
    'zone-collection',
    class ZoneCollection extends HTMLElement {
      static STORAGE_KEY = 'zone-finder-data';

      constructor() {
        super();
        
        // Store unsubscribe function (following the same pattern)
        this.unsubscribeZoneUpdate = null;
        
        // Bind event handlers (following the same pattern)
        this.handleZoneUpdate = this.handleZoneUpdate.bind(this);
      }

      connectedCallback() {
        // Don't load in Shopify's design mode
        if (window.Shopify && window.Shopify.designMode) {
          return;
        }
        
        // Subscribe to zone update events (SAME PATTERN as other components)
        this.unsubscribeZoneUpdate = subscribe(PUB_SUB_EVENTS.zoneUpdate, this.handleZoneUpdate);
        
        // Set up intersection observer for initial load
        this.setupIntersectionObserver();
      }

      disconnectedCallback() {
        // Clean up subscription (SAME PATTERN as other components)
        if (this.unsubscribeZoneUpdate) {
          this.unsubscribeZoneUpdate();
          this.unsubscribeZoneUpdate = null;
        }
      }

      handleZoneUpdate(eventData) {
        // SAME VALIDATION PATTERN as other components
        if (eventData && eventData.zipCode && eventData.zoneData && eventData.zoneData.success) {
          // Re-render with new zone data
          this.renderNewZoneContent(eventData.zoneData);
        }
      }

      renderNewZoneContent(zoneData) {
        // Check if we have a collection URL for this zone
        if (!zoneData.collectionURL) {
          this.innerHTML = ''; // Clear content if no collection available
          return;
        }
        
        // Show loading state while fetching new content
        //this.innerHTML = '<div class="zone-collection__loading">Loading products for your zone...</div>';
        
        // Fetch new content for the updated zone
        const url = `${zoneData.collectionURL}?section_id=zone-collection-ajax`;
        
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const zoneContent = html.querySelector('.collection');

            if (zoneContent && zoneContent.innerHTML.trim().length) {
              this.innerHTML = zoneContent.outerHTML;
            } else {
              this.innerHTML = '<div class="zone-collection__empty">No products available for this zone</div>';
            }
          })
          .catch((error) => {
            this.innerHTML = '<div class="zone-collection__error">Unable to load products for this zone</div>';
          });
      }

      setupIntersectionObserver() {
        // Check if we should set up intersection observer
        const zoneURL = this.getZoneCollectionURL();
        if (!zoneURL) {
          return;
        }
        
        // Set up intersection observer for initial load
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          
          // Unobserve after first intersection (one-time execution)
          observer.unobserve(this);
          
          this.loadInitialContent(zoneURL);
        };

        // Same margin pattern as ProductRecommendations
        new IntersectionObserver(handleIntersection.bind(this), { 
          rootMargin: '0px 0px 400px 0px' 
        }).observe(this);
      }

      getZoneCollectionURL() {
        try {
          const storedData = localStorage.getItem(ZoneCollection.STORAGE_KEY);
          if (storedData) {
            const parsedData = JSON.parse(storedData);
            if (parsedData.zoneData && parsedData.zoneData.collectionURL) {
              return `${parsedData.zoneData.collectionURL}?section_id=zone-collection-ajax`;
            }
          }
        } catch (error) {
          // Silently handle localStorage errors
        }
        return null;
      }

      loadInitialContent(url) {
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const zoneContent = html.querySelector('.collection');

            if (zoneContent && zoneContent.innerHTML.trim().length) {
              this.innerHTML = zoneContent.outerHTML;
            }
          })
          .catch((error) => {
            // Silently fail for initial load
          });
      }
    }
  );
}